<template>
  <section>
    <header>
      <span>Единицы измерения</span>
      <VLink
        material="add"
        @click="addProductCategoryAllowedUnits"
      >
        Добавить
      </VLink>
    </header>

    <div class="content">
      <VDataGridV2
        layout="fill"
        :data="allowedUnits"
      >
        <VDataGridColumnV2
          id="id"
          label="ID"
          width="80px"
        />

        <VDataGridColumnV2
          id="name"
          label="Название"
        />

        <VDataGridColumnV2
          id="action"
          width="105px"
          content-align="right"
        >
          <template #default="{ row }">
            <VButton @click="detachedUnit(row)">
              <template #icon>
                <VIcon material="delete"/>
              </template>
            </VButton>
          </template>
        </VDataGridColumnV2>
      </VDataGridV2>
    </div>
  </section>
</template>

<script lang="ts">

import ProductCategory          from '@/domains/ProductCategories/ProductCategory';
import ProductCategoriesService from '@/domains/ProductCategories/ProductCategoriesService';

export default defineComponent({
	name: 'ProductCategoryAllowedUnits',

	props: {
		productCategory: {
			type:    Object,
			default: null,
		},
	},

	emits: ['change', ProductCategory.Events.AttachUnit, ProductCategory.Events.DetachUnit],

	computed: {
		/** Имеется ли у продуктовой категории список разрешённых единиц измерения */
		haveAllowedUnits(): boolean {
			return (
				this.$core.utils.isObject(this.productCategory)
				&& Array.isArray(this.productCategory.allowedUnits)
				&& this.productCategory.allowedUnits.length > 0
			);
		},

		/** Список разрешённых единиц измерения для отображения в таблице */
		allowedUnits(): any[] {
			return this.haveAllowedUnits ? this.productCategory.allowedUnits : [];
		},
	},

	methods: {
		/**
		 * Открыть диалог добавления разрешённых единиц измерения для категории
		 */
		addProductCategoryAllowedUnits(): void {
			ProductCategoriesService.showProductCategoryAllowedUnitsDialog(
				this.productCategory,
				this.attachedUnit,
				this.detachedUnit,
			);
		},

		/**
		 * Привязать единицу измерения к категории
		 */
		attachedUnit(unit: any): void {
			ProductCategoriesService
				.attachAllowedUnit(this.productCategory.id, unit.id)
				.then(() => {
					this.$emit(ProductCategory.Events.AttachUnit, unit);
					this.$emit('change');
				});
		},

		/**
		 * Отвязать единицу измерения от категории
		 */
		detachedUnit(unit: any): void {
			ProductCategoriesService
				.detachAllowedUnit(this.productCategory.id, unit.id)
				.then(() => {
					this.$emit(ProductCategory.Events.DetachUnit);
					this.$emit('change');
				});
		},
	},
});
</script>
